import { Component, Input, OnInit } from '@angular/core';
import { JsonViewerService } from './json-viewer.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-compare-json',
    imports: [CommonModule, ButtonModule],
    template: `
  @for (key of keys; track key;){
    <span class="json-field">
        <span [ngClass]="compareJson(key)?'key nopadding capitalize' : 'key row-change nopadding capitalize'">"{{key}}":</span>
        @if(this.getDataType(key, originalJSONObject) === 'object'){
        <span>
        <div class="col-md-12 subcontainer">
          <app-compare-json class="nopadding" [originalJSONObject]="(getPretyJsonValue(key,originalJSONObject))"  [selectedJSONObject]="(getPretyJsonValue(key,selectedJSONObject))"></app-compare-json>
        </div>
        </span>}
        @if(this.getDataType(key, originalJSONObject) !== 'object'){
        <span [ngClass]="compareJson(key)?'nopadding' : 'row-change nopadding'">{{getJsonValue(key,originalJSONObject)}}</span>
        }
      <br>
    </span>}
  `,
    styles: [`
  .row {
    margin:0px;
    padding:0px;
  }
  .row-change{
    background-color: #fe0 !important;
    color:green;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .subcontainer{
    font-weight: 600 !important;
    margin: 0px !important;
    padding-left: 20px !important;
    padding-bottom: 10px !important;
  }

  pre {
    font-weight: 400 !important;
    display: table !important;
    padding: 1px !important;
    margin: 0px !important;

    .number-line {
      color: #adadaf !important;
    }
    .string {
      color: #95c602 !important;
    }
    .number {
      color: #f2b619 !important;
    }
    .boolean {
      color: #0097f1 !important;
    }
    .null {
      color: #727990 !important;
    }
    .key {
      color: black !important;
    }
  }
    .json-field {
      width:auto !important;
      display: table !important;
    }
  `]
})
export class CompareJsonComponent implements OnInit {

  @Input('originalJSONObject') originalJSONObject: any;
  @Input('selectedJSONObject') selectedJSONObject: any;
  keys: any = [];

  constructor(private jsonViewerService: JsonViewerService) {
  }

  ngOnInit() {
    if (this.selectedJSONObject == ""
      || this.selectedJSONObject == null
      || (Object.keys(this.selectedJSONObject).length === 0)) {
      this.selectedJSONObject = this.originalJSONObject;
    }
    if (this.originalJSONObject == ""
      || this.originalJSONObject == null
      || (Object.keys(this.originalJSONObject).length === 0)) {
      this.originalJSONObject = this.selectedJSONObject;
    }
    this.originalJSONObject = this.jsonViewerService.convertToObject(this.originalJSONObject);
    this.selectedJSONObject = this.jsonViewerService.convertToObject(this.selectedJSONObject);
    this.keys = Object.keys(this.originalJSONObject);
  }
  getDataType(key:any, data:any) {
    return typeof (data[key]);
  }
  getJsonValue(key:any, data:any) {
    if (this.getDataType(key, data) === 'object') {
      return JSON.stringify(data[key]);
    }
    return data[key];
  }

  getPretyJsonValue(key:any, data:any) {
    let objectKeyDetails:any=data[key];
    if (this.getDataType(key, data) === 'object') {
      let sortdata  =   this.jsonViewerService.sortObject(objectKeyDetails);
      return JSON.stringify(sortdata,null,2);
    }
    return objectKeyDetails;
  }
  
  compareJson(key:any) {
    return (this.getJsonValue(key, this.originalJSONObject) == this.getJsonValue(key, this.selectedJSONObject) ? true : false)
  }

}
